$(document).on('click','.djJs-postOnConfirm',function(e){

    e.preventDefault();

    var url          = $(this).data('url');
    var questionText = $(this).data('question');
    var confirmText  = $(this).data('confirm');
    var elShow       = $(this).data('show');
    var elHide       = $(this).data('hide');

    var r = confirm(questionText);
    if (r == true) {
        $.ajax({
            type: "POST",
            url: url,
            success: function()
            {
                if (elShow !== undefined) {
                    $(elShow).removeClass('hidden');
                }

                if (elHide !== undefined) {
                    $(elHide).addClass('hidden');
                }

                if (typeof confirmText !== 'undefined') {
                    window.alert(confirmText);
                }
            }
        });
    }
});
